// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
      	removePriceDecimal: true,
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale_banner">' + bcSfFilterConfig.label.sale + '</div>',
    'newLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.new + '</div>',
    'comingsoonLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.coming_soon + '</div>',
    'preorderLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.pre_order + '</div>',
    'vendorHtml': '<br /><span itemprop="brand">{{itemVendorLabel}}</span>',
    'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop action_button" data-gallery="product-{{itemId}}-gallery">' + bcSfFilterConfig.label.quick_shop + '</span>',
    'newRowHtml': '<br class="clear product_clear" />',

    // Grid Template
    'productGridItemHtml': '<div class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupMobileClass}}" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product">' +
                                '<a href="{{itemUrl}}" itemprop="url">' +
                                    '<div class="relative product_image">' +
                                        '{{itemImages}}' +
                                        '{{itemQuickViewBtn}}' +
                                    '</div>' +
                                    '<div class="info">' +
                                        '<span class="title" itemprop="name">{{itemTitle}}</span>' +
                                        '{{itemVendor}}' +
                                        '{{itemPrice}}' +
                                    '</div>' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemNewLabel}}' +
                                    '{{itemComingsoonLabel}}' +
                                    '{{itemPreorderLabel}}' +
                                '</a>' +
                                '{{itemColorSwatches}}' +
                            '</div>' +
                            '{{itemNewRow}}',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + bcSfFilterConfig.label.paginate_prev + '</a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.paginate_next + ' »</a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="inline">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select" class="sort_by">{{sortingItems}}</select>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add custom class
    var itemColumnNumberClass = '';
    var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, bcSfFilterConfig.custom.products_per_row);
    var itemCollectionGroupMobileClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
    if (bcSfFilterConfig.custom.show_sidebar) {
        switch (bcSfFilterConfig.custom.products_per_row) {
            case 2: itemColumnNumberClass = 'six columns'; break;
            case 3: itemColumnNumberClass = 'four columns'; break;
            default: itemColumnNumberClass = 'three columns'; break;
        }
    } else {
        switch (bcSfFilterConfig.custom.products_per_row) {
            case 2: itemColumnNumberClass = 'eight columns'; break;
            case 3: itemColumnNumberClass = 'one-third column'; break;
            default: itemColumnNumberClass = 'four columns'; break;
        }
    }
    itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);    
    itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);    
    itemHtml = itemHtml.replace(/{{itemCollectionGroupMobileClass}}/g, itemCollectionGroupMobileClass);

    // Add soldOut item
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
  
    // Add onSale label
    var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Get Label (New, Comming soon, Pre order) from Collection
    var itemNewLabelHtml = '', itemComingsoonLabelHtml = '', itemPreorderLabelHtml = '';
    if (data.collections) {
        var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
        itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? bcSfFilterTemplate.newLabelHtml : '';

        var comingsoonLabel = data.collections.filter(function(e) { return e.handle == 'coming-soon'; });
        itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? bcSfFilterTemplate.comingsoonLabelHtml : '';

        var preorderLabel = data.collections.filter(function(e) { return e.handle == 'pre-order'; });
        itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? bcSfFilterTemplate.preorderLabelHtml : '';
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);
    itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);

    // Add Quick view button
    var itemQuickViewBtnHtml = bcSfFilterConfig.custom.quick_shop_enable ? bcSfFilterTemplate.quickViewBtnHtml : '';
    itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

    // Get image source
    var imageSrc = 'data-src="' + this.getFeaturedImage(images, '2048x') + '" ';
    imageSrc += 'data-srcset=" ' + this.getFeaturedImage(images, '2048x') + ' 2048w,';
    imageSrc += this.getFeaturedImage(images, '1600x') + ' 1600w,';
    imageSrc += this.getFeaturedImage(images, '1200x') + ' 1200w,';
    imageSrc += this.getFeaturedImage(images, '1000x') + ' 1000w,';
    imageSrc += this.getFeaturedImage(images, '800x') + ' 800w,';
    imageSrc += this.getFeaturedImage(images, '600x') + ' 600w,';
    imageSrc += this.getFeaturedImage(images, '400x') + ' 400w"';
    // Get Thumbnail url
    var thumbUrl = this.getFeaturedImage(images, '100x');
    // Get Flip image url
    var flipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '900x') : this.getFeaturedImage(images, '900x');

    // Add Thumbnail
    var product_set_width = data.featured_image.width;
    var align_height_value = '';
  	var swapClass = '';
    if (bcSfFilterConfig.custom.collection_secondary_image && images.length > 1) {
      swapClass = 'swap-true';      
    } else {
        swapClass = 'swap-false';
    }
    if (bcSfFilterConfig.custom.align_height) {
        if (images.length > 0) {
            var collection_height = bcSfFilterConfig.custom.collection_height;
            var product_aspect_ratio = images[0]['width'] / images[0]['height'];
            product_set_width = product_aspect_ratio * collection_height;
            if (images[0]['width'] >= images[0]['height']) {
                var align_height_value = 'width: 100%; height: auto;';
            } else {
                var align_height_value = 'width: 100%;';
            }
        }
    }
    var itemImagesHtml = '';
  	itemImagesHtml += '<div class="product-container ' + swapClass + '">';
  	itemImagesHtml += '<div class="image__container">';
    itemImagesHtml += '<img  src="' + thumbUrl + '" ' +
                        ' alt="{{itemTitle}}"' +
                        ' class="lazyload lazyload--mirage primary"' +
                        ' style="' + align_height_value + ' max-width: ' + data.featured_image.width + 'px;"' +
                        ' data-sizes="auto" ' + imageSrc + '/>';
  	itemImagesHtml += '<div class="transition-helper"></div>';
    itemImagesHtml += '</div>';
    if (bcSfFilterConfig.custom.collection_secondary_image && images.length > 1) {
        itemImagesHtml += '<img src="' + flipImageUrl + '" class="secondary lazyload" alt="{{itemTitle}}" />';
    }
    itemImagesHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    var onSaleClass = onSale ? 'sale' : '';
    var soldOutClass = soldOut ? 'OutOfStock' : 'InStock';
    itemPriceHtml += '<span class="price ' + onSaleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
    //itemPriceHtml += '<meta itemprop="price" content="' + this.formatMoney(data.price_min) + '" />';
    itemPriceHtml += '<meta itemprop="priceCurrency" content="' + bcSfFilterConfig.shop.currency + '" />';
    itemPriceHtml += '<meta itemprop="seller" content="' + bcSfFilterConfig.shop.name + '" />';
    itemPriceHtml += '<meta itemprop="availability" href="http://schema.org/' + soldOutClass + '" />';
    itemPriceHtml += '<meta itemprop="itemCondition" content="New" />';
    if (!soldOut) {
        if (priceVaries && data.price_min > 0) {
            itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + '</em></small> ';
        }
        if (data.price_min > 0) {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += bcSfFilterConfig.label.free_price;
        }
    } else {
        itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out +'</span>';
    }
    if (onSale) {
        itemPriceHtml += ' <span class="was_price"><span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span>';
    }
    itemPriceHtml += '</span></span>';
    
    // custom easylockdown
    if( data.collections ) {
      for(let i = 0; i < data.collections.length; i++ ) {
        if( data.collections[i].id == '262253477966' ) {
          itemPriceHtml = '';
          break;
        }
      }
    }
    // custom easylockdown
  
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);


    // Add Swatches
    var itemColorSwatchesHtml = '';
    if (bcSfFilterConfig.custom.collection_swatches) {
        for (var k in data.options) {
            var option = data['options'][k];
            var downcased_option = option.toLowerCase();
            if (downcased_option.indexOf('color') > -1 || downcased_option.indexOf('colour') > -1) {
                var option_index = k;
                var values = [];
                itemColorSwatchesHtml += '<div class="collection_swatches">';
                for (var i in data.variants) {
                    var variant = data['variants'][i];
                    var value = variant['options'][option_index];
                    if (values.indexOf(value) == -1) {
                        var values = values.join(',');
                        values += ',' + value;
                        values = values.split(',');
                        var fileColorUrl = bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', this.slugify(value) + '.png');
                        fileColorUrl = this.optimizeImage(fileColorUrl, '50x');
                        itemColorSwatchesHtml += '<a href="' + this.buildProductItemUrl(data) + '?variant=' + variant.id + '" class="swatch" data-swatch-name="meta-' + downcased_option + '_' + (value.replace(/\s/g, '_')).toLowerCase() + '">';
                        itemColorSwatchesHtml += '<span data-image="' + this.optimizeImage(variant.image) + '" style="background-image: url(' + fileColorUrl + '); background-color: ' + this.slugify(value.split(' ').pop()) + ';">';
                        itemColorSwatchesHtml += '</span>';
                        itemColorSwatchesHtml += '</a>';
                    }
                }
                itemColorSwatchesHtml += '</div>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, itemColorSwatchesHtml);

    // Add new row
    var itemNewRowHtml = index % bcSfFilterConfig.custom.products_per_row == 0 ? bcSfFilterTemplate.newRowHtml : '';
    itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build advanced class
function buildItemCollectionGroupThumbClass(index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 0) { return 'omega'; }
    else if (temp == 1) { return 'alpha'; }
    return '';
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
          	this.buildSortingEvent();
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;

        var breadcrumbHtml = '<span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="' + bcSfFilterConfig.shop.url + '" title="' + bcSfFilterConfig.shop.title + '" itemprop="item"><span itemprop="name">' + bcSfFilterConfig.label.breadcrumb_home + '</span></a></span>';
        breadcrumbHtml += ' &nbsp; / &nbsp;';
        breadcrumbHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="{{currentCollectionUrl}}" title="{{ currentCollectionTitle}}" itemprop="item"><span itemprop="name">{{currentCollectionTitle}}</span></a></span>';
        // Build Tags
        var currentTagsHtml = '';
        if (Array.isArray(bcSfFilterConfig.general.current_tags)) {
            var current_tags = bcSfFilterConfig.general.current_tags;
            for (var k in current_tags) {
                var tag = current_tags[k];
                currentTagsHtml += ' &nbsp; / &nbsp;';
                currentTagsHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/{{currentCollectionLink}}/' + this.slugify(tag) + '" title="' + tag + '" itemprop="item"><span itemprop="name">' + tag + '</span></a></span>';
            }
        }
        breadcrumbHtml += currentTagsHtml;
        // Build Collection Info
        breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
        // Top Pagination
        // var currentPage = parseInt(this.queryParams.page);
        // var totalPage = Math.ceil(apiData.total_product / this.queryParams.limit);
        // var topPaginationHtml = '&nbsp; / &nbsp;' + (bcSfFilterConfig.label.page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage)
        // breadcrumbHtml += ' <span id="bc-sf-filter-top-pagination">' + topPaginationHtml + '</span>';
        breadcrumbHtml += ' <span id="bc-sf-filter-top-pagination"></span>';

        jQ('.breadcrumb_text').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    collection.init();

    // Build content for Quick view
    if (!this.isMobile() && bcSfFilterConfig.custom.quick_shop_enable) {
        jQ('.thumbnail').each(function (e) {
            if (!jQ(this).next().hasClass('modal')) {
                var _this = this;
                var url = jQ(this).find(" > a").eq(0).attr("href");
                jQ.ajax({
                    type: "GET",
                    url: url + '?view=bc-sf-quickview',
                    success: function(data){
                        jQ(data).insertAfter(jQ(_this));
                    }
                });
            }
        });
    }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    // Add Wrapper for Product list
    if (jQ('#bc-sf-filter-products').children().hasClass('product-list')) {
        jQ('#bc-sf-filter-products').children().children().unwrap();
    }

    // Build Top Pagination
    var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
    var topPaginationHtml = '&nbsp; / &nbsp;' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage);
    jQ('#bc-sf-filter-top-pagination').html(topPaginationHtml);
};

BCSfFilter.prototype.buildFilterOptionGeneralRangeSlider = function(sliderId, amountId, currentMin, currentMax, rangeMin, rangeMax, data) {
    var self = this;
    var slider = document.getElementById(sliderId);
    var sliderRange = data.hasOwnProperty('sliderRange') && data.sliderRange !== null ? parseInt(data.sliderRange) : 4;
    var sliderStep = data.hasOwnProperty('sliderStep') && data.sliderStep !== null ? parseInt(data.sliderStep) : 1;
    var sliderDelimiter = data.hasOwnProperty('sliderDelimiter') && data.sliderDelimiter !== null ? data.sliderDelimiter : '';
    var filterOptionRangeClass = this.class.filterOptionRange; // bc-sf-filter-option-range
    // Case: Slider is divided into multiple ranges
    var rangeDecimals = data.filterType.indexOf('price') > -1 ? this.getSettingValue('general.decimalPriceRange') : 0;
  	if (sliderStep <= 0.1) rangeDecimals = 1;
    if (sliderStep <= 0.01) rangeDecimals = 2;
    if (sliderStep <= 0.001) rangeDecimals = 3;
    if (data.filterType.indexOf('weight') > -1) rangeDecimals = 2;
    if (((rangeMax - rangeMin < sliderStep) || rangeMin == null || rangeMax == null) && this.getSettingValue('general.oneValueRangeSlider')) {
        rangeMin -= 0.0001, rangeMax += 0.0001;
        noUiSlider.create(slider, {
            start: [currentMin, currentMax],
            connect: true, // Display a colored bar between the handles
            behaviour: 'tap', // Move handle on tap, bar is draggable
            animate: true,
            animationDuration: 300,
            step: sliderStep,
            range: {
                'min': rangeMin,
                'max': rangeMax
            }
        });
        jQ(slider).attr('disabled', ' disabled');
    } else {    
        // Case: Slider is divided into multiple ranges
        if (sliderRange > 0) {
            // Fix in case the max steps of range less then the sliderRange
            var maxStep = Math.floor((rangeMax - rangeMin) / sliderStep);
            if (maxStep < sliderRange) {
                sliderRange = maxStep;
            }
            var rangeArr = [];
            for (var i = 0; i < sliderRange; i++) {
                rangeArr.push(i * (100 / sliderRange));
            }
            rangeArr.push(100);
            noUiSlider.create(slider, {
                start: [currentMin, currentMax],
                connect: true, // Display a colored bar between the handles
                behaviour: 'tap', // Move handle on tap, bar is draggable
                animate: true,
                animationDuration: 300,
                step: sliderStep,
                range: {
                    'min': rangeMin,
                    'max': rangeMax
                },
                pips: {
                    mode: 'positions',
                    values: rangeArr,
                    density: sliderRange,
                    format: wNumb({
                        decimals: rangeDecimals,
                        thousand: sliderDelimiter,
                        edit: function(value) {
                            return self.buildShortenPipLabels(value, sliderDelimiter);
                        }
                    })
                }
            });
            if (!this.getSettingValue('general.enableSliderRuler')) jQ('#' + sliderId).addClass('no-ruler');
            jQ('#' + sliderId).addClass('has-pips');
            slider.noUiSlider.on('update', function() {
                var last_pips = jQ('#' + sliderId + ' .noUi-pips').find('.noUi-marker').last();
                if (last_pips.hasClass('noUi-marker-normal')) {
                    last_pips.removeClass('noUi-marker-normal');
                    last_pips.addClass('noUi-marker-large');
                    last_pips.after('<div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 100.00000%">' + Math.ceil(rangeMax) + '</div>');
                }
            });
        // Case: Slider doesn't have range
        } else {
            noUiSlider.create(slider, {
                start: [currentMin, currentMax],
                connect: true, // Display a colored bar between the handles
                behaviour: 'tap', // Move handle on tap, bar is draggable
                animate: true,
                animationDuration: 300,
                step: sliderStep,
                range: {
                    'min': rangeMin,
                    'max': rangeMax
                }
            });
        }
        // Slide event
        this.slideEvent(sliderId, amountId, rangeMin, rangeMax, data);
        // onChange event for textboxes
        // When the Range has two textboxes (style1)
        if (this.getSettingValue('general.rangeStyle') == 'style1') {
            var amountMin = filterOptionRangeClass + '-amount-min', amountMax = filterOptionRangeClass + '-amount-max';
            // Format value for display
            var displayValue = this.customizeDisplayRangeValue(currentMin, currentMax, data.filterType, data);
            var displayMin = displayValue[0], displayMax = displayValue[1];
            jQ('#' + amountId).find('.' + amountMin).val(displayMin);
            jQ('#' + amountId).find('.' + amountMax).val(displayMax);
            // onChange event
            jQ('#' + amountId).on('change', '.' + amountMin, function() {
                var minValue = jQ(this).val();
                var maxValue = jQ('#' + amountId + ' .' + amountMax).val();
                slider.noUiSlider.set([minValue, maxValue]);
            });
            jQ('#' + amountId).on('change', '.' + amountMax, function() {
                var maxValue = jQ(this).val();
                var minValue = jQ('#' + amountId + ' .' + amountMin).val();
                slider.noUiSlider.set([minValue, maxValue]);
            });
        }
        // Set event
        this.setRangeValueEvent(sliderId, rangeMin, rangeMax, data);
    }
};
// Build link for other sections like: pagination, limit, sort, display
BCSfFilter.prototype.buildToolbarLink = function(type, oldValue, newValue) {
  var link = window.location.href;
  var oldParam = type + '=' + oldValue;
  var newParam = type + '=' + newValue;
  if (link.indexOf('?' + type + '=') > -1) {
    link = link.replace('?' + oldParam, '?' + newParam);
  } else {
    // Check the param whether exists in url
    // If Yes, replace old param with new param
    if (link.indexOf('&' + type + '=') > -1) {
      link = link.replace('&' + oldParam, '&' + newParam);
    }
    // If No, append new param to url
    else {
      if (window.location.search.length === 0) {
        link += '?' + newParam;
      } else {
        link = link.replace('?', '?' + newParam + '&');
      }
    }
  }
  // Remove page param if page = 1
  if (type == 'page' && newValue == 1) {
    link = link.replace('?page=1&', '?').replace('?page=1', '');
  }
  // Remove page param if firing an event which is different with the page event
  var additionalParams = ['display', 'sort', 'page', 'limit'];
  if (this.queryParams.hasOwnProperty('page') && additionalParams.indexOf(type) == -1) {
    var paginationParam = '&page=' + this.queryParams.page;
    link = link.replace(paginationParam, '');
  }
  if(type === "sort"){
  	var paginationParam = '&page=' + this.queryParams.page;
    var paginationParam2 = 'page=' + this.queryParams.page+ '&';
    link = link.replace(paginationParam, '');
    link = link.replace(paginationParam2, '')
  }
  return link;
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
